import React from "react";
import { Link } from "react-router-dom"

export default function Support() {
    return (
        <div>
            Support page 
            <Link to="/" className="underline">
                "go to dashboard"
            </Link>
        </div>
    )
}